module.exports = __webpack_public_path__ + "static/accordion1-05026024817132cb992aae5ecb03763b.png";